export const DEV = "development";
export const PROD = "production";
export const TEST = "test";